// extracted by mini-css-extract-plugin
export default {"root":"PartnerList_root__nLNW1","logo":"PartnerList_logo__-ldyj","heading":"PartnerList_heading__RSNyM"};